import {useTranslation} from 'react-i18next';

import {Box, CardMedia, Grid, SxProps, Typography} from '@mui/material';

import {bodyPdf, bodyPdfExtraLineHeight, pdfH1, pdfH4} from '../styles';

import cardImage from '../../../../assets/pdf/analysis_guide/page_one.png';
import {greenColors} from '../../../../layouts/theme/designSystem';

export const FirstPage = () => {
  const {t} = useTranslation('pdfDomain', {keyPrefix: 'analysisGuide.firstPage'});
  const {t: tr} = useTranslation('pdfDomain', {keyPrefix: 'analysisGuide.firstPage.beforeReading'});
  const {t: ta} = useTranslation('pdfDomain', {keyPrefix: 'analysisGuide.firstPage.whileReading'});

  const textStyle: SxProps = {
    color: greenColors[700],
    fontSize: '17px',
    fontWeight: 700,
    marginBottom: 2,
  };

  const cardMediaStyle: SxProps = {height: '200px', width: '730px', borderRadius: '16px'};

  return (
    <>
      <Box height={'500px'} p={5}>
        <Typography variant='h1' sx={pdfH1} mb={2}>
          {t('pageTitle')}
        </Typography>
        <Typography sx={bodyPdf} mb={1}>
          {t('blockOne')}
        </Typography>
        <Typography sx={bodyPdf} mb={1}>
          {t('blockTwo')}
        </Typography>
        <Typography sx={bodyPdf} mb={1}>
          {t('blockThree')}
        </Typography>
      </Box>
      <Grid container item justifyContent='center' marginTop={'-50px'}>
        <CardMedia component='img' image={cardImage} sx={cardMediaStyle} />
        <Grid container item width={'700px'} justifyContent={'space-between'} mt={5}>
          <Typography variant='h4' sx={pdfH4} mb={2}>
            {t('sectionTitle')}
          </Typography>
          <Grid item width={'340px'} mr={1}>
            <Typography sx={textStyle}> {tr('title')}</Typography>
            <Typography sx={bodyPdfExtraLineHeight}>&#8226; {tr('bulletOne')}</Typography>
            <Typography sx={bodyPdfExtraLineHeight}>&#8226; {tr('bulletTwo')}</Typography>
            <Typography sx={bodyPdfExtraLineHeight}>&#8226; {tr('bulletThree')}</Typography>
          </Grid>
          <Grid item width={'340px'}>
            <Typography sx={textStyle}>{ta('title')}</Typography>
            <Typography sx={bodyPdfExtraLineHeight}>&#8226; {ta('bulletOne')}</Typography>
            <Typography sx={bodyPdfExtraLineHeight}>&#8226; {ta('bulletTwo')}</Typography>
            <Typography sx={bodyPdfExtraLineHeight}>&#8226; {ta('bulletThree')}</Typography>
            <Typography sx={bodyPdfExtraLineHeight}>&#8226; {ta('bulletFour')}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
